
(function(){
    function getCookieValueByLoop(a, b, c, d, e) {
        b = document.cookie.split('; ');
        for (e = b.length - 1; e >= 0; e--) {
           c = b[e].split('=');
           if (a === c[0]) return c[1];
        }
        return '';
    }
    function init(countdown_date) {
      const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;

      const countDown = new Date(countdown_date+"T00:00:00.000-06:00"),
            x = setInterval(function() {    

              const now = new Date().getTime(),
                    distance = countDown - now;

              document.getElementById("days").innerText = Math.floor(distance / (day)),
                document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
                document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
                document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);

              if (distance < 0) {
                
                document.getElementById("countdown").style.display = "none";
                clearInterval(x);
              }

            }, 0);
        
    }
  if(document.getElementById("countdown")){
    let countdown_date = document.getElementById("countdown").getAttribute('data-date');
    if(countdown_date != ''){
    	init(countdown_date);
    }
    
  }
  })();
